<template>
  <div class='appointBox' style='width: calc(95% - 200px);'>
    <div class='eq_header'>
      <div style='font-size: 24px;font-family: Source Han Sans SC;font-weight: bold;color: #333333;'>
        扣分记录</div>
      <span style='font-size:14px;color:#999999'>您的位置：个人中心><span style="color:#188335">扣分记录</span></span>
    </div>
    <div style='width: 100%;'>
      <div class='sdau_search'>
        <el-form ref="form" :model="formData" label-width="100px" :inline="true">
          <el-row>
            <el-col :span='8'>
              <el-form-item label="预约时间">
                <el-date-picker @change="handleTime" v-model="dateRange" size="small" value-format="yyyy-MM-dd"
                  type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="截止日期"
                  clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="预约单号">
                <el-input placeholder="请输入设预约单号" v-model="formData.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="formData.equipmentName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="处理原因">
                <el-input placeholder="请输入处理原因" v-model="formData.remark"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
              </el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="e_reset">重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" :index='Nindex' width="55" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="code" label="预约单号" align="center">
        </el-table-column>
        <el-table-column prop="equipmentNumber" label="设备编号" align="center">
        </el-table-column>
        <el-table-column prop="equipmentName" label="设备名称" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" width="140" label="预约申请日期" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="reservationStartTime" width="140" label="预约起始时间" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="reservationEndTime" width="140" label="预约截止时间" align="center">
        </el-table-column>
        <el-table-column prop="type" label="违规事项" align="center">
          <template slot-scope="scope">
            <span v-if="typeData[Number(scope.row.type)]">{{ typeData[Number(scope.row.type)].label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scoreChange" label="违规处理" align="center">
          <template slot-scope="scope">
            <span v-if='Number(scope.row.scoreChange) > 0'>{{ '+' + scope.row.scoreChange }}</span>
            <span v-else>{{ scope.row.scoreChange }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total > 0" :pageSizes="pageSizes" :total="total" :page.sync="formData.pageNum"
        :limit.sync="formData.pageSize" @pagination='init' />
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {
  },
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 5,
      },
      total: 1,
      pageSizes: [5, 10, 20, 50, 100, 300],
      tableData: [],
      dateRange: [],
      typeData: [
        { value: 0, label: '管理员调整' },
        { value: 1, label: '超时扣分' },
        { value: 2, label: '爽约扣分' },
        { value: 3, label: '取消预约扣分' },
        { value: 4, label: '迟到扣分' }
      ]
    }
  },
  methods: {
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
      }
      this.dateRange = []
      this.init()
    },
    handleTime(date) {
      if (date) {
        this.formData.createTimeStart = date[0]
        this.formData.createTimeEnd = date[1]
      } else {
        this.formData.createTimeStart = []
        this.formData.createTimeEnd = []
      }
    },
    Nindex(index) {
      const page = this.formData.pageNum
      const pagesize = this.formData.pageSize
      return index + 1 + (page - 1) * pagesize
    },
    init() {
      this.$net(`/sdau/creditScoreManagement/queryMyRecord`, 'get', this.formData).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },

  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table th {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #666666;
}

::v-deep .el-table td {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
}

.eq_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>